/**
 * PointerCell Component
 * 
 * Renders Parse Pointer values as clickable pills:
 * - Shows truncated objectId
 * - Arrow icon to indicate it's a link
 * - Tooltip with full class and objectId
 * - Click triggers navigation to referenced object
 */

import { CellRendererProps, ParsePointer } from '../../../../../types/AppPanel';

export default function PointerCell({ 
  value, 
  onPointerClick, 
  targetClass 
}: CellRendererProps<ParsePointer | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }

  // Handle both Parse REST format and raw format
  const className = value.className || targetClass || 'Unknown';
  const objectId = value.objectId || (typeof value === 'string' ? value : null);

  if (!objectId) {
    return <span className="text-white/30 italic">(invalid pointer)</span>;
  }

  // Truncate objectId for display
  const displayId = objectId.length > 10 ? objectId.slice(0, 10) : objectId;

  const handleClick = () => {
    onPointerClick?.({ __type: 'Pointer', className, objectId });
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full 
                 bg-[#208AEC]/20 text-[#208AEC] text-xs font-medium
                 hover:bg-[#208AEC]/30 transition-colors cursor-pointer"
      title={`${className}: ${objectId}`}
    >
      <span className="text-[#208AEC]/60">→</span>
      {displayId}
    </button>
  );
}

